__turbopack_context__.v({
  "arrowContainer": "Arrow-module__9SPhwa__arrowContainer",
  "arrowContainerMobile": "Arrow-module__9SPhwa__arrowContainerMobile",
  "arrowPath": "Arrow-module__9SPhwa__arrowPath",
  "floatDown": "Arrow-module__9SPhwa__floatDown",
});
